import { render, staticRenderFns } from "./abnormal-order.vue?vue&type=template&id=5064d17a&scoped=true&"
import script from "./abnormal-order.vue?vue&type=script&lang=js&"
export * from "./abnormal-order.vue?vue&type=script&lang=js&"
import style0 from "./abnormal-order.vue?vue&type=style&index=0&id=5064d17a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5064d17a",
  null
  
)

export default component.exports